/**
 *Created by jmmartinez on 18/03/19
 *  v 1.1 08/11/2019 Eliminado botón volver
 *  v 1.2 24/04/2020 Añadido onFileUploaded en propTypes
 *  v 1.3 05/05/2020 Añadida función eliminarFileDeAcceptedFiles
 *  v.2.0 30/09/2020 Cambiado a framework2
 */

import React from 'react'
import PropTypes from 'prop-types';

import Dropzone from 'react-dropzone'
import {Container, Col, Row} from 'react-grid-system';
import {Button, ProgressBar, Intent, Icon} from "@blueprintjs/core";
import {posPrimerElementoConValorPropiedad, delPosicion} from "../utils/ArrayUtils"


const baseStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 200,
    height: 200,
    padding: 4,
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};


const thumb = {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 200,
    height: 200,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};
const filename = {
    display: 'block',
    width: 'auto',
    height: '100%',
    fontSize: 8,
};

const titulo= "Arrastre un fichero aquí o haga Click para seleccionar";

class FileUploader extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            imagen: null,
            acceptedFiles: [],
            progreso: 0,
        }
    }



    onAcceptFiles= (acceptedFiles) => {
        //console.log("FU - OnAcceptFiles");
        //console.log(acceptedFiles);
        let acceptedFilesConPreviews= acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        }));

        this.setState({acceptedFiles: acceptedFilesConPreviews});
    }

    enviar= () => {
        const {acceptedFiles} = this.state;
        const {url} = this.props;
        this.sendRequest(url, acceptedFiles[0]);
    }

    fileUploaded= (file) => {
        const {onFileUploaded} = this.props;
        console.log("fileUploaded");
        this.eliminarFileDeAcceptedFiles(file);
        onFileUploaded && onFileUploaded(file);
    }

    eliminarFileDeAcceptedFiles= (file) => {
        const {acceptedFiles} = this.state;
        let pos= posPrimerElementoConValorPropiedad(acceptedFiles, "name", file.name);
        console.log("Pos: " + pos);
        if (pos >= 0){
            let newAcceptedFiles= [];
            if (acceptedFiles.length > 1)
                newAcceptedFiles= acceptedFiles.splice(pos, 1);
            this.setState({acceptedFiles: newAcceptedFiles});
        }
    }

    fileError= () => {
        const {onFileError} = this.props;
        onFileError && onFileError();
    }



    sendRequest(url, file) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            //req.setRequestHeader()

            req.upload.addEventListener("progress", event => {
                let progreso= (event.loaded / event.total) * 100;
                console.log(progreso);
                this.setState({ progreso: progreso});
            });

            req.upload.addEventListener("load", event => {
                this.setState({ progreso: 100});
                resolve(req.response);
                this.fileUploaded(file);
            });

            req.upload.addEventListener("error", event => {
                console.log("ERROR");
                reject(req.response);
                this.fileError();
            });

            const formData = new FormData();
            /*
            console.log("ENVIANDO");
            console.log(file);
            console.log("url:", url);
            */
            formData.append("file", file, file.name);
            req.open("POST", url);
            req.send(formData);
        });
    }

    render() {
        const {imagen, acceptedFiles, progreso} = this.state;

        //console.log("acceptedFiles:");
        //console.log(acceptedFiles);

        const thumbs = acceptedFiles.map(file => (
            <div style={thumb} key={file.name}>
                <div style={thumbInner}> <img src={file.preview} style={img}/> </div>
                <div style={filename}>{file.name}</div>
                <div>
                    {progreso < 0 &&
                        <Icon icon={"error"} intent={Intent.INTENT_DANGER}/>
                    }
                    {progreso >= 100 &&
                        <Icon icon={"tick-circle"} intent={Intent.SUCCESS}/>
                    }
                    {progreso >= 0 && progreso < 100 &&
                    <ProgressBar intent={Intent.SUCCESS} value={progreso}/>
                    }
                </div>

            </div>
        ));

        return (
            <>
                <Dropzone onDrop={this.onAcceptFiles} disabled={false} multiple={false}
                          accept={['image/*']}>
                    {({isDragAccept, isDragActive, isDragReject, getRootProps, getInputProps}) => {
                        let borderColor= '#eeeeee';
                        if (isDragAccept)
                            borderColor= '#00ff00';
                        if (isDragReject)
                            borderColor= '#ff0000';
                        return (
                            <Container  fluid={true}>
                                <Row>
                                    <Col md={4}>
                                        <section style={ {...baseStyle, borderColor}}>
                                            <div {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                <p>{titulo}</p>
                                            </div>
                                        </section>
                                    </Col>
                                    <Col md={4}>
                                        {thumbs}
                                    </Col>
                                </Row>
                            </Container>
                        )
                        }
                    }
                </Dropzone>

                <div className="botonera">
                    {acceptedFiles.length > 0 &&
                        <Button icon="saved" className="boton" onClick={this.enviar}>Enviar</Button>
                    }
                </div>
            </>
        )
    }


}


FileUploader.propTypes = {
    url: PropTypes.string,
    onFileUploaded: PropTypes.func,
    onFileError: PropTypes.func,

}

export default FileUploader;